<div class="percentage-input">
    <img
        (click)="input.focus()"
        *ngIf="showSymbol"
        src="/assets/images/payhoa/other/percentage.svg"
    />
    <!-- suppress HtmlUnknownAttribute -->
    <input
        #input
        (blur)="setValueFromDisplay($event.target.value); blurred.emit(true); inputValueChanged.emit($event.target.value)"
        (focus)="$event.target.select()"
        [(ngModel)]="displayAmount"
        [attr.required]="required"
        [class.dollar-padding]="showSymbol"
        [class.error]="error"
        [class.form-control-sm]="!showSymbol"
        [class.no-money-padding]="!showSymbol"
        [readonly]="readonly"
        class="form-control"
        placeholder="{{ placeholder }}"
        type="text"
    />
</div>
